import classNames from 'classnames';
import type { FC } from 'react';
import { t } from 'src/lib/player/i18n';
import { triggerReload } from 'src/lib/player/model';
import { useStore } from 'src/lib/player/store';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';

export const ReloadButton: FC = () => {
  const reloadInterval = useStore((state) => state.events.at(0)?.options.reloadInterval ?? 0);
  const eventId = useStore((state) => state.eventId);
  const isReloading = useStore((state) => state.isReloading);
  const reloadIsDisabled = reloadInterval === 0;

  async function handleReloadClick() {
    if (isReloading) return;
    try {
      await triggerReload(eventId);
    } catch (err) {
      console.error('Failed to reload event info:', err);
    }
  }

  if (reloadIsDisabled) return null;

  return (
    <div
      className={classNames('side-bar-toolbar-button', { 'disabled': isReloading })}
      title={t('Reload')}
      {...onClickGenerator(() => handleReloadClick())}
    >
      <i
        className={classNames('fas', {
          'fa-spinner fa-spin': isReloading,
          'fa-sync-alt': !isReloading,
        })}
      />
    </div>
  );
};
